import React from 'react'

export const Fuaim = () => {
  return (
    <div>More details to come...</div>
  )
}
